import React, { useState } from "react";
import { Transition } from "@headlessui/react";
import { useLocation } from "react-router-dom";
import Button from "../elements/Button";
import BrandIcon2 from "./BrandIcon2";
import "../assets/css/header2.css";

export default function Header2() {
  const [isCollapse, setIsCollapse] = useState(false);
  const location = useLocation();
  const path = location.pathname;

  const handleScrollToCompanies = (event) => {
    event.preventDefault(); // Prevents default anchor behavior

    if (location.pathname === "/") {
      // If already on LandingPage, scroll smoothly
      const section = document.getElementById("part3");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // If on another page, navigate to home first
      navigate("/#part3");
    }
  };

  return (
    <header className="header2">
      <div className="flex justify-between px-4 lg:px-0">
        <BrandIcon2 />

        <button
          className="block text-theme-blue lg:hidden focus:outline-none"
          onClick={() => setIsCollapse(!isCollapse)}
        >
          <svg
            className="w-8 h-8"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              className={`${isCollapse ? "hidden" : "block"}`}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            />
            <path
              className={`${!isCollapse ? "hidden" : "block"}`}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <ul className="hidden text-theme-blue tracking-widest items-center lg:flex flex-row mt-0">
        <li>
          <Button
            className={`${
              path === "/" ? "active-link" : ""
            } font-medium px-5 no-underline hover:underline`}
            type="link"
            href="/LandingPage2"
          >
            Home
          </Button>
        </li>
        <li>
          <Button
            className={`${
              path === "/" ? "active-link" : ""
            } font-medium px-5 no-underline hover:underline`}
            type="link"
            href="/aboutUs2"
          >
            About us
          </Button>
        </li>
        <li className="py-2 lg:py-0">
          <Button
            className={`${
              path === "/team" ? "active-link" : ""
            } font-medium px-5 no-underline hover:underline`}
            type="link"
            href="/team2"
          >
            Our Team
          </Button>
        </li>
        <li>
          <Button
            className={`${
              path === "/" ? "active-link" : ""
            } font-medium px-5 no-underline hover:underline`}
            type="link"
            href="/LandingPage2/#part4"
          >
            Our Companies
          </Button>
        </li>
        <li className="py-2 lg:py-0">
          <Button
            className={`${
              path === "/team" ? "active-link" : ""
            } font-medium px-5 no-underline hover:underline`}
            type="link"
            href="/project2"
          >
            Our Services
          </Button>
        </li>
        <li className="py-2 lg:py-0">
          <Button
            className={`${
              path === "/team" ? "active-link" : ""
            } font-medium px-5 no-underline hover:underline`}
            type="link"
            href="/customers2"
          >
            Our Customers
          </Button>
        </li>
        <li>
          <Button
            className={`${
              path === "/team" ? "active-link" : ""
            } font-medium px-5 no-underline hover:underline`}
            type="link"
            href="/discuss-project2"
          >
            Contact us
          </Button>
        </li>
      </ul>

      <Transition
        show={isCollapse}
        enter="transition-opacity duration-300 ease-in-out"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-300 ease-in-out"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="lg:hidden bg-white w-full absolute top-16 left-0 z-50 border-t-2 border-gray-300">
          <ul className="flex flex-col text-theme-blue tracking-widest space-y-4 py-6">
            <li>
              <Button
                className={`${
                  path === "/" ? "active-link" : ""
                } font-medium px-10 no-underline hover:underline`}
                type="link"
                href="/LandingPage2"
              >
                Home
              </Button>
            </li>
            <li className="py-2 bg-white">
              <Button
                className={`${
                  path === "/" ? "active-link" : ""
                } font-medium px-10 no-underline hover:underline`}
                type="link"
                href="/aboutUs2"
              >
                About us
              </Button>
            </li>
            <li className="py-2 bg-white">
              <Button
                className={`${
                  path === "/team" ? "active-link" : ""
                } font-medium px-10 no-underline hover:underline`}
                type="link"
                href="/team2"
              >
                Team
              </Button>
            </li>
            <li className="py-2 bg-white">
              <Button
                className={`${
                  path === "/team" ? "active-link" : ""
                } font-medium px-10 no-underline hover:underline`}
                type="link"
                href="/LandingPage2/#part4"
              >
                Our Companies
              </Button>
            </li>
            <li className="py-2 bg-white">
              <Button
                className={`${
                  path === "/project" ? "active-link" : ""
                } font-medium px-10 no-underline hover:underline`}
                type="link"
                href="/project2"
              >
                Our Services
              </Button>
            </li>
            <li className="py-2 bg-white">
              <Button
                className={`${
                  path === "/project" ? "active-link" : ""
                } font-medium px-10 no-underline hover:underline`}
                type="link"
                href="/customers2"
              >
                Our Customers
              </Button>
            </li>
            <li className="mx-auto my-9 bg-white">
              <Button
                className={`${
                  path === "/team" ? "active-link" : ""
                } font-medium text-lg px-5 no-underline hover:underline`}
                type="link"
                href="/discuss-project2"
              >
                Contact us
              </Button>
            </li>
          </ul>
        </div>
      </Transition>
    </header>
  );
}
